import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { addVehicle, getAllVehicles, getVehiclesFulfilled, getVehicleById, updateVehicleById } from './vehicle_thunk';

const initialState = {
  vehicles: [],
  status: '',
  message: ''
}

export const vehicleSlice = createSlice({
  name: 'vehicles',
  initialState,
  extraReducers: {
    [getAllVehicles.pending]: asyncIsPending,
    [getAllVehicles.rejected]: asyncIsRejected,
    [getAllVehicles.fulfilled]: getVehiclesFulfilled,
    [getVehicleById.pending]: asyncIsPending,
    [getVehicleById.rejected]: asyncIsRejected,
    [getVehicleById.fulfilled]: getVehiclesFulfilled,
    [addVehicle.pending]: asyncIsPending,
    [addVehicle.rejected]: asyncIsRejected,
    [addVehicle.fulfilled]: asyncIsFulfilled,
    [updateVehicleById.pending]: asyncIsPending,
    [updateVehicleById.rejected]: asyncIsRejected,
    [updateVehicleById.fulfilled]: asyncIsFulfilled,
  }
});

export default vehicleSlice.reducer;